import { render, staticRenderFns } from "./PackageViewLogs.vue?vue&type=template&id=457b05c0"
import script from "./PackageViewLogs.vue?vue&type=script&lang=js"
export * from "./PackageViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports